const devConfig = {
  MASTER_TOKEN: 'tGdp3GxthgOgEZkCnhgAYKqMt1vDkjrc',
  IMAGEURL: './public/images/',
  BASE_URL: 'http://localhost:9003/'
};

module.exports = devConfig;
